import Radium from 'radium';
import React, { Component } from 'react';
import { getWeeknumber } from '../../../Util/dateTime';
import { httpGet } from '../../../Util/http';


class SalaryFeed extends Component {
    constructor(props) {
        super(props)
        this.state = {
            feed: [],
            executed: false
        }
    }
    componentDidMount() {
        setTimeout(() => {
            let _url = process.env.REACT_APP_webApiEndPoint + 'api/salary/feed?skip=0&take=100';
            httpGet(_url)
            .then(resp => resp.json())
            .then(resp => this.setState({
                feed: resp
            }))
        }, 400)
    }
    
    render() {
        return (
            <div style={{
                marginTop: 8,
                textAlign: 'center',
                width: '100%',
                height: 500,
                overflow: 'auto'
            }}>
                <div style={styles.Heading}>
                    <div style={styles.headingText}>Aktivitetsfeed</div>
                </div>
                {this.state.feed.map((ev, idx) => {
                    if(ev.text !== "printede lønkørsel") {
                        return null
                    }
                    return (
                        <div  onClick={() => {
                            this.props.onClick(ev)
                        }} key={idx} style={{position: 'relative', backgroundColor: 'white', padding: '12px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between'}}>
                            <span title={ev.data.projects} style={{}}>{ev.user} printede lønsedler for {ev.data.projectIds && ev.data.projectIds.length || 0} sager i perioden uge {getWeeknumber(ev.data.dateFrom)} til uge {getWeeknumber(ev.data.dateTo)}.<i style={{marginLeft: 8}} className="fa fa-external-link" aria-hidden="true"></i></span> 
                            
                            <span> {ev.timestamp} siden</span>
                        </div>
                    )
                })}
            </div>
        );
    }
}
var styles = {
    Heading: {
        paddingBottom: '1px',
        position: 'relative',
        width: '100%'

    },
    headingText: {
        width: '100%',
        display: 'inline-block',
        backgroundColor: 'white',
        padding: '5px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 600,
    },
}

export default Radium(SalaryFeed)


// WEBPACK FOOTER //
// ./src/App/Project/Salary/CreateSalary/SalaryFeed.js